export const HEADER_LOGO = {
    img: '../img/ggbet_logo.png',
    alt: 'GGBet'
};